<template>
  <div class="error-container">
    <div class="center-error-container">
      <h1 class="error-heading">404</h1>
      <p class="error-desc">Seite nicht gefunden!</p>
      <base-button type="secondary" class="mt-4" @click="goBack">Zurück zur Startseite</base-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NotFound",
    data() {
      return {}
    },
    methods: {
      goBack() {
        this.$router.push('dashboard')
      }
    }
  }
</script>

<style scoped>
  .error-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-color: #1da1f2;
    height: 100vh;
  }
  .center-error-container {
    color: #FFFFFF;
    text-align: center;
  }
  .center-error-container > .error-heading {
    color: #FFFFFF;
    margin: 0;
    font-size: 128px;
  }
  .center-error-container > .error-desc {
    margin: 0;
    font-size: 24px;
  }
</style>